import React from 'react'
import ViewHeader from '../../components/ViewHeader';
import { FaCheck, FaEye, FaBan } from 'react-icons/fa';
import { SUCCESS, NOTIF_ERROR, MODE_EDIT, NOTIF_SUCCESS, MODE_PENDING, PENDING_ADS_LIST, BLACK, GREEN, RED, NO, SECONDARY, YES, DANGER, LINK, PENDING_ADVERTISEMENTS, SUCCESS_BUTTON, PAGINATION_NUMBER } from '../../../utils/constants';
import { connect } from 'react-redux';
import { adsOperations } from './state';
import { bindActionCreators } from 'redux'
import { SideNotification } from '../../../utils/common';
import { MSG_DEFAULT_ERROR, DECLINE_PENDING_ADS, DECLINE_ADS, APPROVE_ADS, APPROVE } from '../../../utils/messages';
import TableTemplate from '../../components/TableTemplate';
import { VIEW_STORE_ROUTE } from './routes';
import { withRouter } from 'react-router-dom';
import { isNullOrUndefined } from '../../../../node_modules/util';
import ConfirmationModal from '../../components/ConfirmationModal';
import debounce from 'lodash.debounce';
import Pagination from '../../components/PaginationTemplate';

class Advertisement extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            storeId: props.storeId,
            pendingList: [],
            showDeleteModal: false,
            showApproveModal: false,
            modalId: null,
            activePage: 1,
            totalPages: 0
        };

        this.declineAdvertisement = debounce(this.declineAdvertisement.bind(this), 500);
        this.approveAdvertisement = debounce(this.approveAdvertisement.bind(this), 500);

    }

    componentDidMount() {
        this.retrievePendingList();
    }

    retrievePendingList = () => {
        let data = {
            "pageNumber": this.state.activePage
        }
        this.props.getPendingAdsList(data, this.state.storeId)
            .then(response => {
                if (SUCCESS === response.status) {
                    this.setState({ pendingList: response.data.list, totalPages: response.data.totalPage })
                } else {
                    SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR);
                }
            })
    }

    handlePageClick = (pageNumber) => {
        this.setState({ activePage: pageNumber }, () => this.retrieveList());
    }

    handlePagePrev = () => {
        this.setState({ activePage: this.state.activePage - PAGINATION_NUMBER }, () => this.retrieveList());
    }

    handlePageNext = () => {
        this.setState({ activePage: this.state.activePage + PAGINATION_NUMBER }, () => this.retrieveList());
    }

    handlePageFirst = () => {
        this.setState({ activePage: PAGINATION_NUMBER }, () => this.retrieveList());
    }

    handlePageLast = () => {
        this.setState({ activePage: this.state.totalPages }, () => this.retrieveList());
    }

    toggleDelete = (row) => {
        this.setState(prevState => ({ showDeleteModal: !prevState.showDeleteModal, modalId: isNullOrUndefined(row) ? null : row.adsId }))
    }

    toggleApprove = (row) => {
        this.setState(prevState => ({ showApproveModal: !prevState.showApproveModal, modalId: isNullOrUndefined(row) ? null : row.adsId }))
    }

    declineAdvertisement = () => {
        this.props.deleteAd(this.state.modalId)
            .then((result) => {
                if (SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, result.message);
                    this.retrievePendingList();
                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }
                this.toggleDelete();
            });
    }

    approveAdvertisement = () => {
        this.props.approveAd(this.state.modalId)
            .then((result) => {
                if (SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, result.message);
                    this.retrievePendingList();
                    this.props.getAdsList(this.state.storeId, this.props.adsSearch);
                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }
                this.toggleApprove();
            });
    }

    viewAd = (data, type) => {
        let params = {};

        params.data = data;
        params.type = type;

        this.props.history.push({
            pathname: VIEW_STORE_ROUTE + `/${this.state.storeId}/ads/${data.adsId}`,
            state: params
        })
    }

    render() {
        return (
            <div>
                <ViewHeader
                    title={PENDING_ADS_LIST}
                />
                <TableTemplate
                    tableName={PENDING_ADVERTISEMENTS}
                    tableColumns={this.props.tableColumns}
                    tableHeader={this.props.tableHeaders}
                    tableList={this.state.pendingList}
                    rowButtons={[
                        { variant: LINK, icon: FaEye, color: BLACK, onClick: this.viewAd, type: MODE_PENDING },
                        { variant: LINK, icon: FaCheck, color: GREEN, onClick: this.toggleApprove, type: MODE_EDIT },
                        { variant: LINK, icon: FaBan, color: RED, onClick: this.toggleDelete }
                    ]}
                />

                <Pagination
                    {...this.state}
                    handlePageClick={this.handlePageClick}
                    handlePagePrev={this.handlePagePrev}
                    handlePageNext={this.handlePageNext}
                    handlePageLast={this.handlePageLast}
                    handlePageFirst={this.handlePageFirst}
                />

                <ConfirmationModal
                    show={this.state.showDeleteModal}
                    toggleModal={this.toggleDelete}
                    title={DECLINE_PENDING_ADS}
                    message={DECLINE_ADS}
                    modalButtons={[
                        { label: NO, onClick: this.toggleDelete, variant: SECONDARY },
                        { label: YES, onClick: this.declineAdvertisement, variant: DANGER }
                    ]}
                />
                <ConfirmationModal
                    show={this.state.showApproveModal}
                    toggleModal={this.toggleApprove}
                    title={APPROVE_ADS}
                    message={APPROVE}
                    modalButtons={[
                        { label: NO, onClick: this.toggleApprove, variant: SECONDARY },
                        { label: YES, onClick: this.approveAdvertisement, variant: SUCCESS_BUTTON }
                    ]}
                />
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        tableHeaders: state.ads.pendingTable.tableHeaders,
        tableColumns: state.ads.pendingTable.tableColumns
    };
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        getPendingAdsList: adsOperations.getPendingAdsList,
        deleteAd: adsOperations.deleteAd,
        approveAd: adsOperations.approveAd,
        getAdsList: adsOperations.getAdsList
    },
    dispatch
);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Advertisement));